import { QueryBuilderEntityValueOptionType } from '../../../../types';

export const filterValueOptionsBySearch = (
  options: QueryBuilderEntityValueOptionType[],
  search: string
): QueryBuilderEntityValueOptionType[] => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) {
    return options;
  }

  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedSearch)
  );
};
